<form [formGroup]="searchForm" (submit)="submit()">
    <mat-form-field class="col-12">
        @if (!isLoadingResults) {
            <mat-icon matIconPrefix>search</mat-icon>
        }
        <mat-label>Search</mat-label>
        <input
            formControlName="search"
            matInput
            type="text"
            placeholder="Search"
            [appDisableControl]="isLoadingResults"
        />
        @if (!isLoadingResults && !submitCompleted) {
            <button type="submit" color="primary" mat-button matTextSuffix class="mb-2">SEARCH</button>
        }
        @if (!isLoadingResults && submitCompleted) {
            <button
                type="button"
                mat-icon-button
                [disabled]="isLoadingResults"
                (click)="cleanInput()"
                class="me-2"
                matIconSuffix
            >
                <mat-icon>close</mat-icon>
            </button>
        }
        @if (isLoadingResults) {
            <mat-icon matIconSuffix>
                <mat-spinner diameter="24" />
            </mat-icon>
        }
        <mat-error>
            <app-field-error [field]="'search'" [messageList]="formError['search']" />
        </mat-error>
    </mat-form-field>
</form>
